import React, { useEffect, useState } from "react";
import {
  AgoraVideoPlayer,
  createClient,
  createMicrophoneAndCameraTracks,
} from "agora-rtc-react";
import { getRTCToken } from "../chat/AgoraMethods";
import { getPrivilegeExipryRTM } from "../../../util/helpers";
import "../chat/ChatStyles.css";
import { ReactComponent as MicOff } from "../../../assets/icons/MicOff.svg";
import { ReactComponent as MicOn } from "../../../assets/icons/MicOn.svg";
import { ReactComponent as VideoOff } from "../../../assets/icons/VideoOff.svg";
import { ReactComponent as VideoOn } from "../../../assets/icons/VideoOn.svg";
import { ReactComponent as EndCall } from "../../../assets/icons/EndCall.svg";
import { RtmRole } from "agora-access-token";

const appId = process.env.REACT_APP_AGORA_ID;
const role = RtmRole.Rtm_User;
const token = getRTCToken(
  process.env.REACT_APP_AGORA_ID,
  process.env.REACT_APP_AGORA_CERTIFICATE,
  "8211",
  role,
  getPrivilegeExipryRTM(),
  "something"
);
const token2 =
  "007eJxTYIjvbZPMz9Jy28Juen2ZgpyJ2NQtokeUVE4v99x9Q+az0i0FhkRLcyPjpCQjC2MTMxNTyyQLUyDf0tzUKNHCIDHVxLBJY0NKQyAjw5491xgZGSAQxOdkKM7PTS3JyMxLZ2AAAAmYHzA=";
const config = {
  mode: "rtc",
  appId: appId,
  token: token2,
  codec: "vp8",
};

const useClient = createClient(config);
const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();

const Videos = (props) => {
  const { users, tracks } = props;

  return (
    <div className="container-fluid w-100">
      <AgoraVideoPlayer
        videoTrack={tracks[1]}
        style={{ height: "70vh", width: "100%" }}
      />
      {users.length > 0 &&
        users.map((user) => {
          if (user.videoTrack) {
            return (
              <AgoraVideoPlayer
                videoTrack={user.videoTrack}
                key={user.uid}
                style={{ height: "70vh", width: "100%" }}
              />
            );
          } else return null;
        })}
    </div>
  );
};

export const Controls = (props) => {
  const client = useClient();
  const { tracks, setStart, setInCall } = props;
  const [trackState, setTrackState] = useState({ video: true, audio: true });

  const mute = async (type) => {
    if (type === "audio") {
      await tracks[0].setEnabled(!trackState.audio);
      setTrackState((ps) => {
        return { ...ps, audio: !ps.audio };
      });
    } else if (type === "video") {
      await tracks[1].setEnabled(!trackState.video);
      setTrackState((ps) => {
        return { ...ps, video: !ps.video };
      });
    }
  };

  const leaveChannel = async () => {
    await client.leave();
    client.removeAllListeners();
    tracks[0].close();
    tracks[1].close();
    setStart(false);
    setInCall(false);
  };

  return (
    <div className="control-container">
      {trackState.audio ? (
        <MicOn onClick={() => mute("audio")} style={{ cursor: "pointer" }} />
      ) : (
        <MicOff onClick={() => mute("audio")} style={{ cursor: "pointer" }} />
      )}

      <EndCall onClick={() => leaveChannel()} style={{ cursor: "pointer" }} />

      {trackState.video ? (
        <VideoOn onClick={() => mute("video")} style={{ cursor: "pointer" }} />
      ) : (
        <VideoOff onClick={() => mute("video")} style={{ cursor: "pointer" }} />
      )}
    </div>
  );
};

const ChannelForm = (props) => {
  const { setInCall, setChannelName } = props;

  return (
    <form className="join">
      {config?.appId === "" && (
        <p style={{ color: "red" }}>Agora AppID is invalid!</p>
      )}
      <div className="d-flex">
        <input
          type="text"
          placeholder="Enter Channel Name"
          onChange={(e) => setChannelName(e.target.value)}
        />
        <button
          className="primary-btn"
          style={{ borderRadius: "0px" }}
          onClick={(e) => {
            e.preventDefault();
            setInCall(true);
          }}
        >
          Join
        </button>
      </div>
    </form>
  );
};

const VideoCall = (props) => {
  const { setInCall, channelName } = props;
  const [users, setUsers] = useState([]);
  const [start, setStart] = useState(false);
  const client = useClient();
  const { ready, tracks } = useMicrophoneAndCameraTracks();

  useEffect(() => {
    // function to initialise the SDK
    let init = async (name) => {
      console.log("init", name);
      client.on("user-published", async (user, mediaType) => {
        await client.subscribe(user, mediaType);
        console.log("subscribe success");
        if (mediaType === "video") {
          setUsers((prevUsers) => {
            return [...prevUsers, user];
          });
        }
        if (mediaType === "audio") {
          user.audioTrack?.play();
        }
      });

      client.on("user-unpublished", (user, type) => {
        console.log("unpublished", user, type);
        if (type === "audio") {
          user.audioTrack?.stop();
        }
        if (type === "video") {
          setUsers((prevUsers) => {
            return prevUsers.filter((User) => User.uid !== user.uid);
          });
        }
      });

      client.on("user-left", (user) => {
        console.log("leaving", user);
        setUsers((prevUsers) => {
          return prevUsers.filter((User) => User.uid !== user.uid);
        });
      });

      await client.join(config.appId, name, config.token, null);
      if (tracks) await client.publish([tracks[0], tracks[1]]);
      setStart(true);
    };

    if (ready && tracks) {
      console.log("init ready");
      init(channelName);
    }

    return () => {
      client.leave();
    };
  }, [channelName, client, ready, tracks]);

  return (
    <div className="App">
      {ready && tracks && (
        <Controls tracks={tracks} setStart={setStart} setInCall={setInCall} />
      )}
      {start && tracks && <Videos users={users} tracks={tracks} />}
    </div>
  );
};

const VideoCallComponent = () => {
  const [inCall, setInCall] = useState(false);
  const [channelName, setChannelName] = useState("Testing");
  return (
    <div className="container-fluid w-100 p-5 m-0 text-center">
      <h1 className="display-4 py-4 mb-2">Testing TeleHealth</h1>

      {inCall ? (
        <VideoCall setInCall={setInCall} channelName={channelName} />
      ) : (
        <ChannelForm setInCall={setInCall} setChannelName={setChannelName} />
      )}
    </div>
  );
};

export default VideoCallComponent;
